<template>
    <b-modal
        :visible="visible"
        title="Como deseja exportar o Excel?"
        hide-footer
        @change="handleVisibleChange"
    >
        <div class="export-options">
            <button
                v-for="option in options"
                :key="String(option.value)"
                class="export-option"
                @click="handleConfirm(option.value)"
            >
                <div class="export-option-title">{{ option.title }}</div>
                <div class="export-option-description">{{ option.description }}</div>
            </button>
        </div>
    </b-modal>
</template>

<script>
export default {
  name: 'ExportOrientationModal',
  props: {
    visible: { type: Boolean, default: false },
    options: { type: Array, default: () => [] }
  },
  methods: {
    handleConfirm (pivoted) {
      this.$emit('confirm', { pivoted })
    },
    handleVisibleChange (isVisible) {
      if (!isVisible) this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
.export-options {
    display: flex;
    flex-direction: column;
    gap: 12px;
}
.export-option {
    text-align: left;
    padding: 16px;
    border: 2px solid #e8e8e8;
    border-radius: 10px;
    background: #fff;
    cursor: pointer;
    transition: all 0.2s ease;
}
.export-option:hover {
    border-color: #FF8C42;
    background: #FFF5EF;
}
.export-option-title {
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 4px;
}
.export-option-description {
    font-size: 0.85rem;
    color: #666;
}
</style>
